import { isApiError } from '../api';

/** A sentence for any thrown error: the API's own message where there is one. */
export function errorMessage(err: unknown): string {
  if (isApiError(err)) {
    if (err.code === 'FORBIDDEN') return `Your role does not allow this. (${err.message})`;
    if (err.code === 'VALIDATION_FAILED') {
      const fields = Object.entries(err.fieldErrors());
      if (fields.length) return `${err.message}: ${fields.map(([k, v]) => `${k || 'form'} — ${v}`).join('; ')}`;
    }
    return err.message;
  }
  if (err instanceof Error) return err.message;
  return 'Something went wrong.';
}

export function fieldErrorsOf(err: unknown): Record<string, string> {
  return isApiError(err) ? err.fieldErrors() : {};
}
